import { types } from "../actionTypes/AgentActionTypes"

const AgentReducer = (state = [], action) => {
    const { payload } = action
    switch(action.type) {
        case types.GET_AGENTS_REQUEST:
            return {
                ...state,
                agentListLoading: true
            }
        case types.GET_AGENTS_SUCCESS:
            return {
                ...state,
                agentListLoading: false,
                agentList: payload.AIBots,
                totalAgents: payload.totalRecords
            }
        case types.GET_AGENTS_FAILURE:
            return {
                ...state,
                agentListLoading: false
            }
        case types.GET_AGENT_DETAILS_REQUEST:
            return {
                ...state,
                agentDetailsLoading: true
            }
        case types.GET_AGENT_DETAILS_SUCCESS:
            return {
                ...state,
                agentDetailsLoading: false,
                agentDetails: payload
            }
        case types.GET_AGENT_DETAILS_FAILURE:
            return {
                ...state,
                agentDetailsLoading: false
            }
        case types.DELETE_AGENT_REQUEST:
            return {
                ...state,
                deleteAgentLoading: true
            }
        case types.DELETE_AGENT_SUCCESS:
            return {
                ...state,
                deleteAgentLoading: false,
            }
        case types.DELETE_AGENT_FAILURE:
            return {
                ...state,
                deleteAgentLoading: false
            }
        case types.ADD_AGENT_REQUEST:
            return {
                ...state,
                addAgentListLoading: true
            }
        case types.ADD_AGENT_SUCCESS:
            return {
                ...state,
                addAgentListLoading: false,
            }
        case types.ADD_AGENT_FAILURE:
            return {
                ...state,
                addAgentListLoading: false
            }
        case types.GET_PERSONA_TYPES_DETAILS:
            return {
                ...state,
                personaTypes: payload
            }
        default:
            return state
    }
}
export default AgentReducer;
